import { VEC3 } from "./vector";
export const INF = 999999999999.11203123;
export const SPHERE_NORMALS = [
    VEC3(0.0, -0.0, -1.0),
    VEC3(0.723608, -0.525725, -0.447219),
    VEC3(-0.276388, -0.850649, -0.447219),
    VEC3(-0.894426, -0.0, -0.447216),
    VEC3(-0.276388, 0.850649, -0.44722),
    VEC3(0.723608, 0.525725, -0.447219),
    VEC3(0.276388, -0.850649, 0.44722),
    VEC3(-0.723608, -0.525725, 0.447219),
    VEC3(-0.723608, 0.525725, 0.447219),
    VEC3(0.276388, 0.850649, 0.447219),
    VEC3(0.894426, 0.0, 0.447216),
    VEC3(-0.0, 0.0, 1.0),
    VEC3(0.425323, -0.309011, -0.850654),
    VEC3(-0.162456, -0.499995, -0.850654),
    VEC3(0.262869, -0.809012, -0.525738),
    VEC3(0.425323, 0.309011, -0.850654),
    VEC3(0.850648, -0.0, -0.525736),
    VEC3(-0.52573, -0.0, -0.850652),
    VEC3(-0.68819, -0.499997, -0.525736),
    VEC3(-0.162456, 0.499995, -0.850654),
    VEC3(-0.68819, 0.499997, -0.525736),
    VEC3(0.262869, 0.809012, -0.525738),
    VEC3(0.951058, 0.309013, 0.0),
    VEC3(0.951058, -0.309013, 0.0),
    VEC3(0.587786, -0.809017, 0.0),
    VEC3(0.0, -1.0, 0.0),
    VEC3(-0.587786, -0.809017, 0.0),
    VEC3(-0.951058, -0.309013, -0.0),
    VEC3(-0.951058, 0.309013, -0.0),
    VEC3(-0.587786, 0.809017, -0.0),
    VEC3(-0.0, 1.0, -0.0),
    VEC3(0.587786, 0.809017, -0.0),
    VEC3(0.68819, -0.499997, 0.525736),
    VEC3(-0.262869, -0.809012, 0.525738),
    VEC3(-0.850648, 0.0, 0.525736),
    VEC3(-0.262869, 0.809012, 0.525738),
    VEC3(0.68819, 0.499997, 0.525736),
    VEC3(0.52573, 0.0, 0.850652),
    VEC3(0.162456, -0.499995, 0.850654),
    VEC3(-0.425323, -0.309011, 0.850654),
    VEC3(-0.425323, 0.309011, 0.850654),
    VEC3(0.162456, 0.499995, 0.850654),
];
